import BlackJackTableView from "./blackjack_table_view";
import BlackJackUtility from "../../Utility/blackJack_utility";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import BlackJackTableLogic from "./blackjack_table_logic";
import LanguageManager from "../../../../manager/language_manager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BlackjackBankerView extends cc.Component {
    
    
    @property(cc.SpriteAtlas)
    spriteAtlasBanker: cc.SpriteAtlas = null
    
    @property(cc.Animation)
    bombEffect: cc.Animation = null;
    
    @property(cc.Node)
    bankCollectPos: cc.Node = null;
    
    @property(cc.Node)
    bankPokerPos: cc.Node = null;
    
    @property(cc.Node)
    bankPokerState: cc.Node = null;

    @property(cc.Node)
    pointNode: cc.Node = null;

    @property(cc.Label)
    bankPointTxt: cc.Label = null;

    
    blackjackView:BlackJackTableView = null;
    blackjackLogic:BlackJackTableLogic=null
    bankPokerList:PokerTablePokerBase[]=[]
    start () {
       
    }
    onLoad(){
        
    }
    reset() {
        this.bankPokerPos.destroyAllChildren();
        this.bankPointTxt.string=""
        this.pointNode.active=false;
        this.bankPokerState.active=false;
        this.bombEffect.node.active=false
        this.bankPokerPos.position=new cc.Vec2(-6,225)
    }
    setLogic(bj:BlackJackTableLogic) {
        if(this.blackjackLogic==null)
        {
            this.blackjackLogic=bj
        }
    }
    setTableView(bj:BlackJackTableView) {
        if(this.blackjackView==null)
        {
            this.blackjackView=bj
        }
    }
    showHand(handPos:number)
    {
        //this.node.active=false
        let name = this.getHandName(handPos);
        //this.bankerHand.spriteFrame = this.getSpriteFrameByName(name);
    }
    private getHandName(type:number){
        // switch(type){
        //     case 0://1000
        //         this.bankerHand.node.position=new cc.Vec2(-2.7,-69)
        //         return 'normal';
        //     case 1://500
        //         this.bankerHand.node.position=new cc.Vec2(145.5,-76)
        //         return 'hand_1';
        //     case 2://100
        //         this.bankerHand.node.position=new cc.Vec2(171.3,-124.4)
        //         return 'hand_2';
        //     case 3://10
        //         this.bankerHand.node.position=new cc.Vec2(50.8,-125.7)
        //         return 'hand_3';
        //     case 4://5
        //         this.bankerHand.node.position=new cc.Vec2(70,-112.5)
        //         return 'hand_4';
        //     case 5://1\
        //         this.bankerHand.node.position=new cc.Vec2(13.2,-63)
        //         return 'hand_5';
        // }
    }
    protected getSpriteFrameByName(key: string){
        return this.spriteAtlasBanker.getSpriteFrame(key)
    }

    initBank(cards: number[], points: number) {
        if (this.pointNode.active)
            this.pointNode.active = false
        for (let i = 0; i < cards.length; i++) {
            let code = cards[i]
            let poker = BlackJackUtility.makePoker(this.blackjackView.pokerPrefab.node, code, this.bankPokerPos, i, code != 0)
            poker.node.position = new cc.Vec2(poker.node.position.x + i * 30, 0)
            this.bankPokerList.push(poker)
            this.blackjackView.bankPokerList.push(poker)
            
        }
        if(cards.length>2)
        {
            let  xPos=(cards.length-2)*7
            this.bankPokerPos.position=new cc.Vec2(this.bankPokerPos.x-xPos,this.bankPokerPos.y)
            
        }
        
        this.showPoint(cards,points)
        
    }
    showPoint(cards: number[], points: number)
    {
        if(cards[1] && cards[1]==0)
            return
        if (points != 0) {
            this.pointNode.active = true
            this.bankPokerState.active=false
            this.bankPointTxt.string = points.toString();
            if (points > 21) {
                this.bankPointTxt.string =""
                if(!this.bombEffect.node.active)
                {
                    this.bombEffect.node.active=true;
                    this.bombEffect.play()
                }
                return
            }
            
            if(points==21 && cards.length==2)
            {
                this.pointNode.active = false
                this.bankPokerState.active=true
                this.bankPokerState.getChildByName("blackjack").active=true
                this.bankPokerState.getChildByName("five").active=false
                
            }
            else if(cards.length==5 && points<=21)
            {
                this.pointNode.active = false
                this.bankPokerState.active=true
                this.bankPokerState.getChildByName("blackjack").active=false
                this.bankPokerState.getChildByName("five").active=true
            }
        }
    }
    delayShowPoint(cards: number[],bankPoint: number = 0) {
        this.scheduleOnce(() => {
            this.showPoint(cards, bankPoint)
            //cc.log("bank", "showPoint")
            // if(this.blackjackLogic.ackId!=13)
            // {
            //     this.blackjackLogic.sendAckId()
            // }
            
        }, 0.8);
    }
}
